// @ts-nocheck
import { useMemo } from 'react'

import { AgGridReact } from '@ag-grid-community/react'



const textFilterParams = {
  buttons: ['reset'],
  debounceMs: 150,
}


function RequestsAgGrid({ requests, onSelectRequest }) {
  const columnDefs = useMemo(() => [
    {
      field: 'display_number',
      headerName: 'ID',
      width: 105,
      hide: true,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: textFilterParams,
    },

    {
	      field: 'org_name',
	      headerName: 'Подрядчик',
	      width: 260,
        rowGroup: true,
        hide: true,
        enableRowGroup: true,
	      filter: 'agTextColumnFilter',
	      floatingFilter: true,
	      filterParams: textFilterParams,
    },

    {
      field: 'location_display',
      headerName: 'Локация',
      width: 105,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: textFilterParams,
      enableRowGroup: true,
    },

    {
      field: 'deposit_name',
      headerName: 'Месторождение',
      width: 150,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: textFilterParams,
      enableRowGroup: true,
    },

    {
      field: 'dns_name',
      headerName: 'ДНС',
      width: 105,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: textFilterParams,
      enableRowGroup: true,
    },

    {
      field: 'bush_name',
      headerName: 'Куст',
      width: 90,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: textFilterParams,
    },

    {
      field: 'well_name',
      headerName: 'Скважина',
      width: 110,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: textFilterParams,
    },

    {
      field: 'requested_by_name',
      headerName: 'Кто затребовал',
      width: 160,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: textFilterParams,
      enableRowGroup: true,
    },

    {
      field: 'status_display',
      headerName: 'Статус',
      width: 120,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: textFilterParams,
      cellStyle: (params) => statusCellStyle(params.data?.status),
    },

    {
      field: 'requested_date',
      headerName: 'Плановая дата КС',
      width: 150,
      valueFormatter: (params) => formatDate(params.value),
    },

    {
      field: 'planned_date',
      headerName: 'Дата отработки подрядчиком',
      width: 190,
      valueFormatter: (params) => formatDate(params.value),
    },

    {
      field: 'completed_at',
      headerName: 'Факт выполнения',
      width: 140,
      filter: 'agTextColumnFilter',
      floatingFilter: true,
      filterParams: textFilterParams,
      valueFormatter: (params) => formatDate(params.value),
      valueGetter: (params) => formatDate(params.data?.completed_at || params.data?.reported_completed_date),
    },

    {
      field: 'deadline_date',
      headerName: 'Крайний срок',
      width: 125,
      valueFormatter: (params) => formatDate(params.value),
    },

    {
      field: 'overdue_days',
      headerName: 'Проср., дн.',
      width: 105,
      valueFormatter: (params) => Number(params.value || 0) ? params.value : '—',
      cellStyle: (params) => overdueCellStyle(params.value),
    },

    {
      field: 'description',
      headerName: 'Примечание',
      flex: 1,
      minWidth: 220,
      suppressHeaderMenuButton: true,
      suppressHeaderFilterButton: true,
      suppressHeaderContextMenu: true,
    },

    {
      field: 'created_at',
      headerName: 'Создана',
      width: 120,
      hide: true,
      valueFormatter: (params) => formatDate(params.value),
    },
  ], [])


  return (
    <>
      <style>{gridStyle}</style>

      <div
        className="ag-theme-alpine requests-grid"
        style={{
          height: 'clamp(260px, 42vh, 520px)',
          minHeight: '260px',
          width: '100%',
        }}
      >
        <AgGridReact
            rowData={requests}
            columnDefs={columnDefs}
            rowHeight={26}
            headerHeight={30}
            floatingFiltersHeight={28}
            animateRows={true}
            groupDisplayType="singleColumn"
            groupDefaultExpanded={1}
            rowGroupPanelShow="always"
            autoGroupColumnDef={{
              headerName: 'Группировка',
              minWidth: 230,
              pinned: 'left',
              cellRendererParams: {
                suppressCount: false,
              },
            }}
            getRowId={(params) => params.data.id}

	            getRowClass={(params) => {
	              if (params.node?.group) return 'request-group-row'

	              if (['DONE', 'REJECTED', 'CANCELED'].includes(params.data?.status)) {
	                return 'request-closed-row'
	              }
	
	              return ''
	            }}

            defaultColDef={{
              sortable: false,
              filter: false,
              floatingFilter: false,
              resizable: true,
              suppressMovable: true,
              enableRowGroup: false,
            }}
            sideBar={{
              toolPanels: ['columns', 'filters'],
              hiddenByDefault: false,
              position: 'right',
            }}
            onRowClicked={(params) => {
	              if (params.node?.group) return
	              onSelectRequest(params.data)
	            }}
	            rowSelection="single"
	          />
      </div>
    </>
  )
}


function formatDate(value) {
  if (!value) return '—'
  return String(value).slice(0, 10)
}

function statusCellStyle(status) {
  const styles = {
    NEW: {
      background: '#d9edf7',
      color: '#31708f',
    },

    ACCEPTED: {
      background: '#fcf8e3',
      color: '#8a6d3b',
    },

    PLANNED: {
      background: '#e8eaf6',
      color: '#303f9f',
    },

    WAITING_CONFIRMATION: {
      background: '#fff3cd',
      color: '#856404',
    },

    DONE: {
      background: '#dff0d8',
      color: '#3c763d',
    },

    REJECTED: {
      background: '#eeeeee',
      color: '#666666',
    },

    CANCELED: {
      background: '#eeeeee',
      color: '#666666',
    },
  }

  return {
    fontWeight: 'bold',
    textAlign: 'center',
    justifyContent: 'center',
    ...(styles[status] || {}),
  }
}

function overdueCellStyle(value) {
  const days = Number(value || 0)

  if (!days) {
    return {
      color: '#667085',
      justifyContent: 'center',
      textAlign: 'center',
    }
  }

  return {
    color: '#b42318',
    background: '#fff1f0',
    fontWeight: 700,
    justifyContent: 'center',
    textAlign: 'center',
  }
}


const gridStyle = `
  .requests-grid {
    --ag-font-size: 12px;
    --ag-row-height: 26px;
    scrollbar-gutter: stable;
  }

  .requests-grid .ag-body-horizontal-scroll {
    display: flex !important;
    height: 16px !important;
    min-height: 16px !important;
    max-height: 16px !important;
  }

  .requests-grid .ag-body-horizontal-scroll-viewport {
    overflow-x: scroll !important;
  }

  .requests-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar {
    height: 14px;
  }

  .requests-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-track {
    background: #eef2f6;
    border-radius: 7px;
  }

  .requests-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb {
    background: #98a2b3;
    border: 3px solid #eef2f6;
    border-radius: 7px;
  }

  .requests-grid .ag-body-horizontal-scroll-viewport::-webkit-scrollbar-thumb:hover {
    background: #667085;
  }

  .requests-grid .ag-header-cell-text {
    font-size: 12px;
    font-weight: 600;
  }

  .requests-grid .ag-floating-filter-input,
  .requests-grid .ag-floating-filter-input input,
  .requests-grid .ag-input-field-input,
  .requests-grid .ag-text-field-input {
    color: #101828 !important;
    -webkit-text-fill-color: #101828 !important;
  }

  .requests-grid .ag-floating-filter-input input::placeholder,
  .requests-grid .ag-input-field-input::placeholder,
  .requests-grid .ag-text-field-input::placeholder {
    color: #667085 !important;
    -webkit-text-fill-color: #667085 !important;
  }

  .requests-grid .ag-cell {
    display: flex;
    align-items: center;
  }

  .requests-grid .request-group-row .ag-cell {
    background: #e9f2fb !important;
    font-weight: bold;
  }

	  .requests-grid .request-group-row .ag-cell {
	    background: #e9f2fb !important;
	    font-weight: bold;
	    color: #1f3b73;
	    cursor: pointer;
	  }

	  .requests-grid .ag-row-selected .ag-cell {
	    background: #fff7e6 !important;
	  }

	  .requests-grid .request-closed-row .ag-cell {
	    background: #f2f4f7 !important;
	    color: #667085;
	  }
	
	`

export default RequestsAgGrid
